import { action } from 'typesafe-actions';
import { LocationActionTypes } from './types';

export const initLocation = (payload: string) => action(LocationActionTypes.INIT_LOCATION, payload);
